import { useEffect, useState } from "react";

export default function Checkout() {
  const [show404, setShow404] = useState(false);

  // Obtener la URL de redirección desde los parámetros
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUrl = urlParams.get("redirect");
  const planType = urlParams.get("plan");

  useEffect(() => {
    // Verificar si los parámetros requeridos están presentes
    if (!redirectUrl || !planType) {
      setShow404(true);
      return;
    }

    // Redireccionar después de 3 segundos si los parámetros están presentes
    const timer = setTimeout(() => {
      window.location.href = redirectUrl;
    }, 1000);

    return () => clearTimeout(timer);
  }, [redirectUrl, planType]);

  // Mostrar la página 404 si no hay parámetros
  if (show404) {
    return (
      <section className="hero-section py-12 pt-24 md:pt-28 min-h-screen flex items-center">
        <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
          <div className="max-w-md mx-auto">
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 text-center border border-gray-200">
              <div className="w-20 h-20 mx-auto mb-6 relative">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
                  <svg
                    className="w-10 h-10 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                    />
                  </svg>
                </div>
              </div>

              <h2 className="text-2xl font-black text-gray-900 mb-3">
                Página no encontrada
              </h2>
              <p className="text-gray-600 mb-6">
                Esta página solo es accesible desde la selección de un plan.
              </p>

              <button
                onClick={() => (window.location.href = "/")}
                className="w-full bg-gradient-to-r from-pink-700 via-pink-700 to-pink-500 hover:from-pink-400 hover:via-pink-700 hover:to-pink-700 hover:brightness-125 text-white font-black py-3 px-6 rounded-xl text-base transition-all duration-700 transform shadow-2xl hover:shadow-pink-500/30 hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2"
              >
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                </svg>
                Volver al inicio
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="hero-section py-12 pt-24 md:pt-28 min-h-screen flex items-center">
      <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
        <div className="max-w-md mx-auto">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 text-center border border-gray-200">
            <div className="w-20 h-20 mx-auto mb-6 relative">
              <div className="absolute inset-0 rounded-full border-4 border-pink-500/20"></div>
              <div className="absolute inset-0 rounded-full border-4 border-pink-500 border-t-transparent animate-spin"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <svg
                  className="w-8 h-8 text-pink-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
            </div>

            <h2 className="text-2xl font-black text-gray-900 mb-3">
              Preparando su pedido
            </h2>
            <p className="text-gray-600 mb-6">Por favor espere...</p>

            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-gradient-to-r from-pink-700 via-pink-700 to-pink-500 h-2 rounded-full animate-pulse"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>

          <div className="mt-6 text-center">
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 shadow-lg border border-gray-200">
              <p className="text-sm text-gray-500">
                Redirección automática en curso...
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
